import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell,
} from 'recharts';
import { formatNumber, CHART_TOOLTIP, CHART_AXIS, CHART_GRID } from './format';
import { EMPTY_TEXT } from '../copy';

// Single-series bar chart for bucketed counts (quota-utilisation histogram).
// Bars warm up as they move right — the visual cue for "more concerning".
//
// Props:
//   data       — [{bucket, count, color?}]
//   height     — px (default 220)
//   xKey       — bucket label key (default 'bucket')
//   yKey       — count key (default 'count')
//   colors     — optional list of colours per bar; falls back to a five-step
//                green → red ramp appropriate for utilisation buckets.
//   unit       — tooltip unit label (default 'users')
export default function Histogram({
  data, height = 220, xKey = 'bucket', yKey = 'count', colors, unit = 'users',
}) {
  if (!data || data.length === 0) {
    return <div className="tile-empty" style={{ minHeight: height }}>{EMPTY_TEXT}</div>;
  }
  // The ramp is drawn from the state tokens, so it follows the theme like
  // everything else. The two intermediate steps are the series teal and orange.
  const defaultColors = ['var(--ok-solid)', 'var(--series-2)', 'var(--warn-solid)', 'var(--series-3)', 'var(--danger-solid)'];
  const palette = colors || defaultColors;
  return (
    <div style={{ width: '100%', height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 8, right: 8, bottom: 8, left: 0 }}>
          <CartesianGrid {...CHART_GRID} />
          <XAxis dataKey={xKey} {...CHART_AXIS} />
          <YAxis {...CHART_AXIS} axisLine={false} tickFormatter={formatNumber} width={36} allowDecimals={false} />
          <Tooltip
            cursor={CHART_TOOLTIP.cursor}
            contentStyle={CHART_TOOLTIP.contentStyle}
            itemStyle={CHART_TOOLTIP.itemStyle}
            labelStyle={CHART_TOOLTIP.labelStyle}
            formatter={(v) => [formatNumber(v), unit]}
          />
          <Bar dataKey={yKey} isAnimationActive={false} radius={[4, 4, 0, 0]}>
            {data.map((entry, i) => (
              <Cell key={i} fill={entry.color || palette[i % palette.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
